import { LitElement, html, css } from 'lit';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import { Liquid } from 'liquidjs';

class DplLiquidComponent extends LitElement {
    static properties = {
        data: { type: String },
        queries: { type: Object, converter: {
                fromAttribute: (value, type) => {
                    if (typeof value === 'object')
                        return value;
                    return JSON.parse(value.replaceAll("'", '"'));
                },
                toAttribute: (value, type) => {
                    console.log('toAttribute:', value, type)
                    if (typeof value === 'object')
                        return value;
                    return JSON.stringify(value);
                }
            } },
        templateContent: { state: true },
        isLoading: { state: true }
    };

    _data = {};
    set data(value) {
        console.log(`data[${typeof value}]:`, value);
        if (value === this._data)
            return;
        try {
            this._data = JSON.parse(value.replaceAll("'", '"'));
            console.log('data is json. value=', this._data)
        }catch (error) {
            this._data = value;
            console.log('data is not json. value=', this._data)
        }
        if(this._setupComplete)
            this.updateTemplate();
    }
    get data() {
        return this._data;
    }

    constructor() {
        super();
        this.queries = {};
        this.templateContent = '';
        this.isLoading = true;
    }

    async firstUpdated() {
        const slot = this.shadowRoot.querySelector('slot');
        slot.assignedNodes({flatten: true});

        const nodes = slot.assignedNodes({flatten: true});

        await this.updateTemplate();
        this._setupComplete = true;
    }

    async updateTemplate() {
        this.isLoading = true;

        const template = this.getSlotContent();
        if (template) {
            if (!this._engine)
                this._engine = new Liquid();
            try {
                this.templateContent = await this._engine.parseAndRender(template, {data: this._data, ...await this.queryResults()});
                console.log('templateContent:', this.templateContent)
            } catch (error) {
                console.error('Error rendering template:', error);
            }
        }
        this.isLoading = false;
    }

    getSlotContent() {
        let content = '';
        const slot = this.shadowRoot.querySelector('slot');
        const nodes2 = slot.assignedNodes({flatten: true});
        for(const n of nodes2) {
            switch (n.nodeType) {
                case Node.TEXT_NODE:
                    content += n.data;
                    break;
                case Node.ELEMENT_NODE:
                    content += n.outerHTML;
                    break;
                default:
                    console.log(`n[${n.nodeType}]: innerHTML=${n.innerHTML} data=${n.data} textContent=${n.textContent} outerHTML=${n.outerHTML}`);
            }
        }
        console.log('content:', content);
        return content;

        const htmlContent = Array.from(nodes2)
            .filter(node => node.nodeType === Node.ELEMENT_NODE)
            .map(element => element.outerHTML)
            .join('');
        console.log('htmlContent:', htmlContent);

        return htmlContent;
    }

    static styles = css`
                :host {
                    display: block;
                    transition: opacity 0.3s ease;
                    opacity: 1;
                }
                :host([isLoading]) {
                    opacity: 0.5;
                }
                slot {
                    display: none;
                }
            `;

    render() {
        return html`
                    <slot @slotchange="${this.updateTemplate}"></slot>
                    ${unsafeHTML(this.templateContent)}
                `;
    }

    async queryResults() {
        const promises = [];
        const results = {}
        for (const [key, value] of Object.entries(this.queries)) {
            if (value) {
                promises.push(new Promise(async (resolve, reject) => {
                    results[key] = await this.query(value);
                    resolve();
                }));
            }
        }
        await Promise.all(promises);
        return results;
    }
    async query(query) {
        const request = await fetch(query);
        if (!request.ok) {
            console.error('Error fetching query:', request);
            return 'Error fetching query';
        }
        try {
            return await request.json();
        } catch (error) {
            console.error('Error parsing query response:', error);
            return 'Error parsing query response';
        }
    }
}

customElements.define('dpl-liquid', DplLiquidComponent);